module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/hero-7d3c03217b46225801e35bbd663f3ff9.jpg";